<p-dialog
  [(visible)]="canShowPreviewModel"
  [contentStyle]="{
    'max-height': '75vh',
    width: 'auto',
    'z-index': '1000',
    overflow: 'overlay'
  }"
  [closable]="false"
  [draggable]="false"
  showEffect="fade"
  [modal]="false"
  [style]="{ width: '80%' }"
  styleClass="preview-modal"
  [resizable]="false">
  <ng-template #header>
    <div class="ui-g-11">
      @if (isCustomerDocumentPreview) {
        <span>Customer Acknowledgement Document Preview</span>
      }
      @if (isPoeInvoicePreview) {
        <span>POE Invoice Preview</span>
      }
      @if (isPoeDocumentPreview) {
        <span>POE Document Preview</span>
      }
      @if (isSOWDocumentPreview) {
        <span>Statement of Work Preview</span>
      }
      @if (isCustomerSurvey) {
        <span>Customer Survey Response</span>
      }
      @if (isPartnerSurvey) {
        <span>Partner Survey Response</span>
      }
      @if (isAdditionalDocPreview) {
        <span>Additional Document Preview</span>
      }
      @if (isHistoryDocument) {
        <span>Saved Document Preview</span>
      }
      @if (isRFPDescriptionPreview) {
        <span>RFP Description Preview</span>
      }
      @if (isRFPAwardPreview) {
        <span>RFP Award Letter Preview</span>
      }
    </div>
    <div
      class="ui-g-1 closesidebar diaclnav"
      (click)="closePreview()"
      (keyup.enter)="closePreview()"
      tabindex="0">
      <i class="mdl2-cancel close-icon"></i>
    </div>
  </ng-template>

  <div class="ui-g">
    <div class="ui-g-3 bg-color-1">
      <div class="mb-3">
        <div class="title">Engagement Id</div>
        <div>{{ engagementDetails.requestDetailId }}</div>
      </div>
      <div class="mb-3">
        <div class="title">Workshop Type</div>
        <div class="word-wrap">{{ engagementDetails.engagementName }}</div>
      </div>
      <div class="mb-3">
        <div class="title">Qualified Amount</div>
        <div class="word-wrap">{{ engagementDetails.qualifiedAmount }}</div>
      </div>
      @if (engagementDetails.incentiveAmount) {
        <div class="mb-3">
          <div class="title">Incentive Amount</div>
          <div class="word-wrap">{{ engagementDetails.incentiveAmount }}</div>
        </div>
      }
      <div class="mb-3">
        <div class="title">Customer name/organization</div>
        <div class="word-wrap">{{ engagementDetails.customerOrgName }}</div>
      </div>
      <div class="mb-3">
        <div class="title">Customer (email domain)</div>
        <div class="word-wrap">{{ engagementDetails.customerDomainName }}</div>
      </div>
      <div class="mb-3">
        <div class="title">Partner organization</div>
        <div class="word-wrap">{{ engagementDetails.partnerOrgName }}</div>
      </div>
      <div class="mb-3">
        <div class="title">Partner requestor email</div>
        <div class="word-wrap">
          {{ engagementDetails.partnerInputRequestorEmail }}
        </div>
      </div>
      @if (
        isPoeDocumentPreview ||
        isSOWDocumentPreview ||
        isPoeInvoicePreview ||
        isCustomerSurvey ||
        isPartnerSurvey ||
        isAdditionalDocPreview ||
        isHistoryDocument ||
        isRFPAwardPreview ||
        isRFPDescriptionPreview
      ) {
        <div class="mb-3">
          <div class="title">Committed Date</div>
          <div>{{ engagementDetails.committedDate | date: 'MM/dd/yyyy' }}</div>
        </div>
      }
      <div class="mb-3">
        <div class="title">30 Day Expiration</div>
        <div>
          {{ engagementDetails.day30ExpirationDate | date: 'MM/dd/yyyy' }}
        </div>
      </div>
      @if (
        isPoeDocumentPreview ||
        isSOWDocumentPreview ||
        isPoeInvoicePreview ||
        isCustomerSurvey ||
        isPartnerSurvey ||
        isAdditionalDocPreview ||
        isHistoryDocument ||
        isRFPAwardPreview ||
        isRFPDescriptionPreview
      ) {
        <div class="mb-3">
          <div class="title">90 Day Expiration</div>
          <div>
            {{ engagementDetails.day90ExpirationDate | date: 'MM/dd/yyyy' }}
          </div>
        </div>
      }
      <div class="mb-3">
        <div class="title">Workshop Completion Date</div>
        <div>
          <p-datepicker
            appendTo="body"
            [iconDisplay]="'input'"
            [showIcon]="true"
            [(ngModel)]="selectedWorkshopCompletionDate"></p-datepicker>
        </div>
        @if (hasWorkshopCompletionDateChanged) {
          <div class="save-cancel-btn mt-2">
            <button
              type="submit"
              pButton
              class="flat btnmr"
              (click)="setWorkshopCompletionDate()">
              Save
            </button>
            <button
              type="button"
              pButton
              (click)="resetWorkshopCompletionDate()"
              class="ui-button-secondary flat">
              Cancel
            </button>
          </div>
        }
      </div>
      @if (
        isAdditionalDocPreview ||
        isSOWDocumentPreview ||
        isPoeDocumentPreview ||
        isPoeInvoicePreview ||
        isHistoryDocument ||
        isRFPAwardPreview ||
        isRFPDescriptionPreview
      ) {
        <div class="mb-3 type-dropdown">
          <form [formGroup]="poeDetailsForm">
            <div class="title">Type</div>
            <p-select
              appendTo="body"
              [options]="poeDocumentType"
              formControlName="poeDocumentTypeName"
              placeholder="--SELECT--"
              optionLabel="type"
              (onChange)="checkType()"></p-select>
            @if (showTypeChangeButtons) {
              <div class="save-cancel-btn mt-2">
                <button
                  type="submit"
                  pButton
                  class="flat btnmr"
                  (click)="setPoeDocumentType()">
                  Save
                </button>
                <button
                  type="button"
                  pButton
                  (click)="resetButton()"
                  class="ui-button-secondary flat">
                  Cancel
                </button>
              </div>
            }
          </form>
        </div>
      }
      @if (
        isPoeDocumentPreview ||
        isSOWDocumentPreview ||
        isPoeInvoicePreview ||
        isHistoryDocument ||
        isRFPAwardPreview ||
        isRFPDescriptionPreview
      ) {
        <div class="mb-3">
          <div class="title">Status</div>
          <div>{{ documentStatus }}</div>
        </div>
      }
      @if (isRFPDescriptionPreview) {
        <div class="mb-3">
          <div class="title">Advisory Incentive</div>
          <div>{{ engagementDetails.milestoneTwoPaymentDesignation }}</div>
        </div>
      }
      @if (isCustomerSurvey || isPartnerSurvey) {
        <div class="mb-3">
          <div class="title">Status</div>
          <div>{{ surveyStatus }}</div>
        </div>
      }
      @if (!isCustomerSurvey && !isPartnerSurvey) {
        <div class="mb-3">
          <div class="title">Upload Date</div>
          <div>{{ documentUploadedDate | date: 'MM/dd/yyyy' }}</div>
        </div>
      }
      @if (isCustomerSurvey || isPartnerSurvey) {
        <div class="mb-3">
          <div class="title">Survey Date</div>
          <div>{{ surveyDate }}</div>
        </div>
      }
    </div>

    <div class="ui-g-9 file-viewer">
      @if (isDocumentPreviewLoading && downloadSpin) {
        <div class="mh">
          <p-progressSpinner
            [style]="{ width: '100px', height: '100px' }"
            strokeWidth="5"
            fill="#EEEEEE"
            animationDuration=".5s"></p-progressSpinner>
        </div>
      }
      @if (!downloadSpin && !isSurveyPreview) {
        <div>
          <div class="no-preview-position">
            <label for="filePreview">No file to preview</label
            ><input type="hidden" id="filePreview" />
          </div>
        </div>
      }
      @if (!isDocumentPreviewLoading) {
        <div>
          <app-preview-file
            [fileContentModel]="fileContentModel"
            [engagementPreviewInput]="engagementPreviewInput">
          </app-preview-file>
        </div>
      }
    </div>
  </div>
  <div class="ui-g" style="width: 100%">
    <div class="ui-g-1"></div>
    <div class="ui-g-10">
      @for (message of msgsUsageDetails; track message) {
        <p-message [life]="3000" [text]="message.detail"></p-message>
      }
    </div>
    <div class="ui-g-1"></div>
    @if (
      isCustomerAckApproval ||
      engagementPreviewInput.isPoePreview ||
      isCustomerSurvey
    ) {
      <div class="ui-g-1">
        <input
          class="next-previous"
          [disabled]="!checkForPrevious()"
          (click)="onPreviousClick()"
          type="button"
          value="« Previous" />
      </div>
    }
    @if (!isPartnerSurvey) {
      <div class="ui-g-10 center">
        @if (
          (isCustomerDocumentPreview && showApproveDeny) ||
          (showApproveDeny &&
            (isPoeDocumentPreview ||
              isSOWDocumentPreview ||
              isPoeInvoicePreview ||
              isRFPDescriptionPreview ||
              isRFPAwardPreview) &&
            engagementDetails.enagementStatus === 'Approved') ||
          (isCustomerSurvey && showApproveDeny)
        ) {
          <button
            type="button"
            pButton
            (click)="onDenyOpen()"
            pTooltip="Reject"
            tooltipPosition="top"
            class="ui-button-info btnpad btnmr button-deny">
            Reject
          </button>
        }
        @if (
          (isCustomerDocumentPreview &&
            showApproveDeny &&
            engagementDetails.enagementStatus &&
            engagementDetails.enagementStatus === 'Eligible') ||
          (showApproveDeny &&
            (isPoeDocumentPreview ||
              isSOWDocumentPreview ||
              isPoeInvoicePreview ||
              isRFPDescriptionPreview ||
              isRFPAwardPreview) &&
            engagementDetails.enagementStatus === 'Approved') ||
          (isCustomerSurvey && showApproveDeny)
        ) {
          <button
            type="button"
            pButton
            (click)="submitForApproval()"
            pTooltip="Approve"
            tooltipPosition="top"
            [disabled]="disableApproval"
            class="ui-button-info btnpad btnmr button-approve">
            Approve
          </button>
        }
      </div>
    }
    @if (
      isCustomerAckApproval ||
      engagementPreviewInput.isPoePreview ||
      isCustomerSurvey
    ) {
      <div class="ui-g-1">
        <input
          class="next-previous next-btn"
          [disabled]="!checkForNext()"
          (click)="onNextClick()"
          type="button"
          value="Next »" />
      </div>
    }
  </div>

  <p-dialog
    [(visible)]="invoiceRejectionModalDisplay"
    [contentStyle]="{
      'max-height': '50em',
      width: 'auto',
      'z-index': '1038px'
    }"
    [closable]="false"
    [draggable]="false"
    showEffect="fade"
    [modal]="false"
    class="modal-position">
    <ng-template #header>
      <div class="ui-g-11">
        <span>Select reasons to reject the document</span>
      </div>
      <div
        class="ui-g-1 closesidebar diaclnav"
        (click)="closeDeclineModal()"
        (keyup.enter)="closeDeclineModal()"
        tabindex="0">
        <i class="mdl2-cancel close-icon"></i>
      </div>
    </ng-template>
    <form [formGroup]="formInvoiceRejection">
      <div class="mb-3">
        <div class="title">Reasons</div>
        <p-multiSelect
          appendTo="body"
          name="invoiceRejectionList"
          placeholder="Select reason for rejecting the invoice"
          [maxSelectedLabels]="2"
          [options]="invoiceRejectionList"
          optionLabel="reason"
          formControlName="invoiceRejectionReason"></p-multiSelect>
      </div>
      @if (hasAdditionalNotesSection) {
        <div class="mb-3">
          <div class="title">Additional Notes (Optional)</div>
          <div>
            <textarea
              pTextarea
              formControlName="additionalNotesRejectionReason"
              class="additional-notes p-1"
              placeholder="Enter Notes"
              rows="5"
              name="additionalNotes"
              maxlength="250"
              aria-label="additionalnotes"></textarea>
            <small class="form-text text-muted">
              <code>{{
                formInvoiceRejection.controls['additionalNotesRejectionReason']
                  .value
                  ? formInvoiceRejection.controls[
                      'additionalNotesRejectionReason'
                    ].value.length
                  : 0
              }}</code>
              of <code>250</code> characters
            </small>
          </div>
        </div>
      }
      <button
        type="button"
        pTooltip="Ok"
        [disabled]="!invoiceDenyButtonEnable"
        tooltipPosition="top"
        class="ui-button-info btnpad btnmr button-ok"
        pButton
        (click)="onDeny()">
        Ok
      </button>
      <button
        type="button"
        pTooltip="Cancel"
        tooltipPosition="top"
        class="ui-button-info btnpad btnmr button-cancel"
        pButton
        (click)="closeDeclineModal()">
        Cancel
      </button>
    </form>
  </p-dialog>
  @if (isApproveReject) {
    <div class="loading-indicator">
      <p-progressSpinner></p-progressSpinner>
    </div>
  }
</p-dialog>
